import React, { useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { styled } from "@mui/material/styles";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";

import { setError, setSuccess, setWarning } from "../../reducers/appSlice";
import api from "../../service/api";
import Page from "../../layout/Page";
import DatosTramite from "./DatosTramite";
import Iniciadores from "./Iniciadores";
import Adjuntos from "../verTramite/DatosAdjuntos";
import Movimiento from "./Movimiento";
import Modal from "../../components/IniciadoresDialog";
import Modal2 from "../../components/IniciadoresDialog2";

const ControlButton = styled(Button)(({ theme }) => ({
  marginRight: theme.spacing(1),
  marginBottom: theme.spacing(1),
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
}));

const TabContainer = styled(Box)(({ theme }) => ({
  [theme.breakpoints.up("lg")]: {
    paddingRight: theme.spacing(10),
    paddingLeft: theme.spacing(10),
  },
}));

function getSteps() {
  return [
    "Datos del trámite",
    "Agregar iniciadores",
    "Adjuntar documentación",
    "Realizar Movimiento",
  ];
}

const AltaTramite = (props) => {
  const datosRef = useRef();
  const movimientoRef = useRef();
  const history = useHistory();
  const dispatch = useDispatch();
  const breadcrumbs = [
    { nombre: "Inicio", ruta: "/" },
    { nombre: "Nuevo expediente", ruta: "" },
  ];
  const [activeStep, setActiveStep] = useState(0);
  const steps = getSteps();

  const [tramiteId, setTramiteId] = useState([]);
  const [datosTramite, setDatosTramite] = useState({
    tipoTramite: "expediente",
    codigoTema: "",
    tema: "",
    soporte: "",
    visibilidad: 1,
    asunto: "",
    observaciones: "",
    folios: 0,
  });
  const [iniciadores, setIniciadores] = useState([]);

  const [guardando, setGuardando] = useState(false);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleNextDatos = () => {
    datosRef.current.validarDatos();
  };

  const handleNextMovimiento = () => {
    movimientoRef.current.validarDatos();
  };

  const handleDatosTramite = (datos) => {
    setDatosTramite(datos);
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleIniciadores = (iniciadores) => {
    setIniciadores(iniciadores);
  };

  const handleGuardarTramite = (continuar) => {
    if (iniciadores.length > 0) {
      guardarTramite(continuar);
    }
    else {
      if (continuar === false) {
        handleOpenModalFinalizar();
      }
      else {
        {
          handleOpenModalSeguir();
        }
      }
    }
  };

  const handleGuardarTramiteFinalizar = () => {
    guardarTramite(false);
  };

  const handleGuardarTramiteSeguir = () => {
    guardarTramite(true);
  };

  const [openModalFinalizar, setOpenModalFinalizar] = React.useState(false);
  const [openModalSeguir, setOpenModalSeguir] = React.useState(false);

  const handleOpenModalFinalizar = () => setOpenModalFinalizar(true);
  const handleOpenModalSeguir = () => setOpenModalSeguir(true);

  const handleCloseModalFinalizar= () => setOpenModalFinalizar(false);
  const handleCloseModalSeguir= () => setOpenModalSeguir(false);

  const handleConfirmFinalizar = () => setOpenModalFinalizar(true);
  const handleConfirmSeguir = () => setOpenModalSeguir(true);

  const handleMovimiento = (datos) => {
    //Chequear que sea tipo trámite y que el perfil sea generador de expedientes
    api
      .registrarMovimiento({
        traId: tramiteId,
        fecha: datos.fecha,
        intId: datos.tipoInforme,
        orfidDest: datos.cod_destino,
        cantFolios: datos.folios,
        observacion: datos.observaciones,
      })
      .then((res) => {
        history.push("/ver_tramite/" + tramiteId);
      })
      .catch((e) => {
        console.log(e.response.data.detalle);
        dispatch(setError(e.response.data.error));
      });
  };

  const handleFinalizar = () => {
    history.push("/ver_tramite/" + tramiteId);
  };

  const guardarTramite = async (continuar) => {

    try {
      
      let mails = iniciadores.filter(element => element.email === null && element.personaId !== null); //traigo todos los iniciadores que no tiene email definidos. excepto los organismos.
      if( datosTramite.soporte === "digital" && mails.length > 0 ){ // compruebo si el soporte es digital y si hay algún iniciador sin email. Aviso y no dejo continuar
        dispatch(setWarning("Para continuar, todas las personas Físicas y Jurídicas deben tener correo electrónico."));
        return false;
      }
      setGuardando(true);
      let reqIniciadores = null;
      if (iniciadores.length > 0) {
        reqIniciadores = iniciadores.map((iniciador, index) => {
          return {
            ID: null,
            TRA_ID: null,
            PRS_ID: iniciador.personaId,
            ORF_ID: iniciador.organismoId,
            DMC_ID: iniciador.domicilioId,
            TDM_ID: iniciador.tipo === "fisica" ? 1 : 5,
            LCD_ID: iniciador.localidadId,
            BRR_ID: null,
            CLL_ID: null,
            NUMERACION: null,
            PISO: null,
            DEPTO: null,
            REFERENCIAS: iniciador.domicilioId ? null : iniciador.domicilio,
            EMAIL: iniciador.email,
          };
        });
      }

      let body = {
        esExpediente: datosTramite.tipoTramite === "expediente" ? "S" : "N",
        vitId: datosTramite.visibilidad,
        temaId: datosTramite.codigoTema,
        tema: datosTramite.tema,
        asunto: datosTramite.asunto,
        observacion: datosTramite.observaciones,
        cantFolios:
        datosTramite.soporte === "digital" ? null : datosTramite.folios,
        digital: datosTramite.soporte === "digital" ? "S" : "N",
        involucrados:
          reqIniciadores !== null
            ? JSON.stringify(reqIniciadores)
            : reqIniciadores,
      };

      let response = await api.guardarTramite(body);
      if (continuar) {
        dispatch(setSuccess("Guardado exitosamente"));
        setTramiteId(response.data);
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      } else {
        history.push("/ver_tramite/" + response.data);
      }
      setGuardando(false);

    } catch (e) {

      console.log(e.response.data.detalle);
      dispatch(setError(e.response.data.error));
      setGuardando(false);

    }

  };

  return (
    <Page breadcrumbs={breadcrumbs}>
      <Stepper activeStep={activeStep} alternativeLabel sx={{ mt: 5, mb: 5 }}>
        {steps.map((label, index) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
      <TabContainer>
        {activeStep !== steps.length ? (
          <div>
            {activeStep === 0 ? (
              <DatosTramite
                ref={datosRef}
                handleDatosTramite={handleDatosTramite}
                datosTramite={datosTramite}
                funcion={props.funcion}
              />
            ) : (
                ""
              )}
            {activeStep === 1 ? (
              <Iniciadores
                handleIniciadores={handleIniciadores}
                iniciadores={iniciadores}
                completo="S"
              />
            ) : (
                ""
              )}
            {activeStep === 2 ? (
              <>
                <Adjuntos id={tramiteId} funcion={props.funcion} />
                <br></br>
                <br></br>
              </>
            ) : (
                ""
              )}
            {activeStep === 3 ? (
              <Movimiento
                ref={movimientoRef}
                soporte={datosTramite.soporte}
                folios={datosTramite.folios}
                handleMovimiento={handleMovimiento}
              />
            ) : (
                ""
              )}
            <Grid container>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <ControlButton
                  variant="plata"
                  disabled={activeStep === 0 || activeStep >= 2}
                  onClick={handleBack}
                >
                  Anterior
                </ControlButton>
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12} textAlign="right">
                {activeStep === 0 ? (
                  <ControlButton variant="verde" onClick={handleNextDatos}>
                    Siguiente
                  </ControlButton>
                ) : (
                    ""
                  )}

                {activeStep === 1 ? (
                  <>
                    <ControlButton
                      variant="verde"                      
                      onClick={() => handleGuardarTramite(true)}
                      disabled={guardando}
                    >
                      Guardar y continuar
                    </ControlButton>
                    <ControlButton
                      variant="verde"                      
                      onClick={() => handleGuardarTramite(false)}
                      disabled={guardando}
                    >
                      Finalizar
                    </ControlButton>
                    {/* Acá esta el mensaje de la No selección de iniciadores */}
                    {/* <Modal
                      open={openModalFinalizar}
                      handleConfirmFinalizar={handleGuardarTramiteFinalizar}
                      handleClose={handleCloseModalFinalizar}
                      title="Iniciadores"
                      responsiveTitle="Modal"
                      closeButton
                      size="md"
                    >
                      No elegiste un iniciador. Si continuás se asignará tu organismo como iniciador. ¿Querés continuar?
                    </Modal> */}
                    <Modal open={openModalFinalizar} handleClose={handleCloseModalFinalizar} size="sm">
                      <Typography variant="titulo" paragraph>
                        Iniciadores
                      </Typography>
                      <Typography variant="cuerpo" paragraph>
                        No elegiste un iniciador. Si continuás se asignará tu organismo como iniciador. ¿Querés continuar?
                      </Typography>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row-reverse",
                        }}
                      >
                        <Button sx={{ m: 1 }} variant="verde" onClick={handleGuardarTramiteFinalizar}>
                          {"Confirmar"}
                        </Button>
                        <Button sx={{ m: 1 }} variant="plata" onClick={handleCloseModalFinalizar}>
                          {"Cancelar"}
                        </Button>
                      </Box>
                    </Modal>
                    <br></br>
                    <br></br>
                    {/* <Modal2
                      open={openModalSeguir}
                      handleConfirmSeguir={handleGuardarTramiteSeguir}
                      handleClose={handleCloseModalSeguir}
                      title="Iniciadores"
                      responsiveTitle="Modal"
                      closeButton
                      size="md"
                    >
                      <p>No elegiste un iniciador. Si continuás se asignará tu organismo como iniciador. ¿Querés continuar?</p>
                    </Modal2> */}
                    <Modal open={openModalSeguir} handleClose={handleCloseModalSeguir} size="sm">
                      <Typography variant="titulo" paragraph>
                        Iniciadores
                      </Typography>
                      <Typography variant="cuerpo" paragraph>
                        No elegiste un iniciador. Si continuás se asignará tu organismo como iniciador. ¿Querés continuar?
                      </Typography>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row-reverse",
                        }}
                      >
                        <Button sx={{ m: 1 }} variant="verde" onClick={handleGuardarTramiteSeguir}>
                          {"Confirmar"}
                        </Button>
                        <Button sx={{ m: 1 }} variant="plata" onClick={handleCloseModalSeguir}>
                          {"Cancelar"}
                        </Button>
                      </Box>
                    </Modal>
                    <br></br>
                    <br></br>
                  </>
                ) : (
                    ""
                  )}
                {activeStep === 2 ? (
                  <>
                    <ControlButton variant="verde" onClick={handleNext}>
                      Continuar
                    </ControlButton>
                    <ControlButton variant="verde" onClick={handleFinalizar}>
                      Finalizar
                    </ControlButton>
                  </>
                ) : (
                    ""
                  )}
                {activeStep === 3 ? (
                  <>
                    <ControlButton
                      variant="verde"
                      onClick={handleNextMovimiento}
                    >
                      Mover y finalizar
                    </ControlButton>
                    <ControlButton variant="verde" onClick={handleFinalizar}>
                      Finalizar
                    </ControlButton>
                  </>
                ) : (
                    ""
                  )}
              </Grid>
            </Grid>
          </div>
        ) : (
            <div>
              {/* Si no hay mas pasos tira eso, simplemente debería salir de la pantalla*/}
              <Typography>Finalizado</Typography>
            </div>
          )}
      </TabContainer>
    </Page>
  );
};

export default AltaTramite;
